import {
  BottomNav,
  CatalogMenu,
  Footer,
  Header,
  NewNavbar,
  OfflineContent,
  SideNav,
} from '@/components/organisms';
import { useEffect, useState } from 'react';
import Notification, { notify } from 'react-notify-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import Head from '@/components/layouts/head';
import { COLOR } from '@/config';
import ReactPixel from 'react-facebook-pixel';
import TopLoader from 'react-top-loader';
import { ACTION_CLIENT } from './redux/client/client.action';
import Routes from './routes';
import { HELPERS } from './utils';
import PATH from './routes/path';
import usePageTracking from './hooks/usePageTracking';
// import { GoogleTagManagerBody, GoogleTagManagerHead } from './utils/GoogleTagManager';
const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTIC;

const App = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [isOnline, setIsOnline] = useState(true);
  const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);

  const { showTopLoadingBar, showHeader, showFooter, showBottomNav } = useSelector((state) => state.activity);
  const { isLoading: isClientLoading } = useSelector((state) => state.client);
  const isLoggedIn = useSelector((state) => state.auth.token);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const unlisten = history.listen((x) => {
      window.scrollTo({ top: 0 });
    });

    const handleOnline = () => {
      setIsOnline(true);
      notify.show('Koneksi telah terhubung', 'success');
    };

    const handleOffline = () => {
      setIsOnline(false);
      notify.show('Tidak bisa terhubung ke server, silahkan cek koneksi Anda', 'warning');
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    const initializeApp = async () => {
      try {
        const clientDataPromise = dispatch(ACTION_CLIENT.getClientData());
        const socialMediaPromise = dispatch(ACTION_CLIENT.getSocialMedia());

        // Tunggu hingga semua pre-fetch selesai sebelum mengatur isInitialLoadComplete
        await Promise.all([clientDataPromise, socialMediaPromise]);

        setIsInitialLoadComplete(true);

        // Google Analytics
        HELPERS.GA.page();

        // Facebook Pixel
        ReactPixel.init(
          process.env.REACT_APP_FACEBOOK_PIXEL,
          {},
          {
            autoConfig: false,
            debug: false,
          }
        );
      } catch (error) {
        console.error('Failed to initialize app:', error);
        notify.show('Gagal memuat data awal. Silakan coba lagi.', 'error');
        setIsInitialLoadComplete(true);
      }
    };

    initializeApp();

    return () => {
      unlisten();
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, [dispatch, history]);

  usePageTracking();

  useEffect(() => {
    if (isLoggedIn) {
      HELPERS.GA.identify(auth?.profile?.uuid, { email: auth?.profile?.email, name: auth?.profile?.name });
    }
  }, [isLoggedIn]);

  const newLandingPaths = [PATH.HOME, PATH.SUBSCRIPTION_PACKAGE];
  const isNewLandingPage = newLandingPaths.includes(location.pathname);

  const renderContent = () => {
    return (
      <>
        {isNewLandingPage ? <NewNavbar /> : showHeader && <NewNavbar enableDynamicColors={false} enableBackgroundTransition={false} />}
        <main className={`${!isNewLandingPage && showHeader ? 'mt-20' : ''}`}>
          {isOnline ? <Routes /> : <OfflineContent />}
        </main>
        {isLoggedIn && showBottomNav && <BottomNav />}
        {showFooter && <Footer />}
      </>
    );
  };

  return (
    <>
      <Head />
      <Notification />
      <TopLoader
        show={showTopLoadingBar || !isInitialLoadComplete || isClientLoading}
        backgroundColor="#ddd"
        thickness={3}
        zIndex={100}
        delay={0}
        color={COLOR.PRIMARY}
        duration={1000}
      />
      {/* <GoogleTagManagerHead />
      <GoogleTagManagerBody /> */}
      {renderContent()}
    </>
  );
};

export default App;
